export default __webpack_public_path__ + "static/media/order_2.828968c8.svg";